import { render } from "./card-detail-dialog.vue?vue&type=template&id=1da82c1f&scoped=true"
import script from "./card-detail-dialog.vue?vue&type=script&lang=js"
export * from "./card-detail-dialog.vue?vue&type=script&lang=js"

import "./card-detail-dialog.vue?vue&type=style&index=0&id=1da82c1f&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da82c1f"]])

export default __exports__